/* eslint-disable multiline-ternary */
import { h, Component } from 'preact';
import { connectStore, BookingState, actions, Actions } from '../../../../store';
import { Properties, LatLong } from '../../../../common';
import Icon from '../../../../common/Icon/Icon';
import Loader from '../../../../common/Loader/Loader';
import { Row } from '../../../../common/Layout/Layout';
import { WithStyles, withStyles } from '../../../../style';
import * as appStyles from '../../../../assets/global.scss';
import { FinText } from '../../../../i18n';

interface PositionOptions {
  enableHighAccuracy?: boolean;
  maximumAge?: number;
  timeout?: number;
}

const positionOptions: PositionOptions = {
  enableHighAccuracy: false,
  timeout: 5000,
  maximumAge: 60 * 60 * 1000, // as per Booking
};

// eslint-disable-next-line no-undef
const getLatLong = (position: GeolocationPosition): LatLong => ({
  lat: position.coords.latitude.toFixed(2),
  long: position.coords.longitude.toFixed(2),
});

export interface LocateMeButtonProps extends Properties {}

interface StoreProps {
  userLocation: LatLong;
  locatingUser: boolean;
}

type EffectiveProps = LocateMeButtonProps & StoreProps & Actions & WithStyles;

const mapStateToProps = ({ ux: { userLocation, locatingUser } }: BookingState): StoreProps => ({
  userLocation,
  locatingUser,
});

@withStyles(appStyles)
@connectStore({ mapStateToProps, actions })
export default class LocateMeButton extends Component<LocateMeButtonProps> {
  getUserLocation = (): void => {
    const { setUserLocation, userLocation, setLocatingUser, disableGeoLocation } = this.props as EffectiveProps;
    setLocatingUser(true);

    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        // eslint-disable-next-line no-undef
        (position: GeolocationPosition) => {
          setUserLocation(getLatLong(position));
        },
        // eslint-disable-next-line no-undef
        (error: GeolocationPositionError) => {
          error.code === error.PERMISSION_DENIED ? disableGeoLocation() : setUserLocation(userLocation);
        },
        positionOptions
      );
    }
  };

  render({ locatingUser, tx }: EffectiveProps): h.JSX.Element {
    return (
      <Row class={tx('ps-xsmall font-body-1 flex--end nordic-blue-900-text')} grow={false}>
        {locatingUser ? (
          <Loader />
        ) : (
          <button class={tx('focusInset')} onClick={this.getUserLocation}>
            <span class={tx('underline ps-xsmall-r')}>
              <FinText id="locationModal.locateMe" />
            </span>
            <Icon iconName="gps-location" class={tx('is-small')} />
          </button>
        )}
      </Row>
    );
  }
}
